// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MainLoader_overlay___wnxD","loader":"MainLoader_loader__Rll3h","loading-rotate":"MainLoader_loading-rotate__NEew5"};